export default __webpack_public_path__ + "static/media/aimate-screenshot-01.6b20da96.png";